module.exports = {
    controller($state, Server, ChaiWebSocket, $rootScope, $timeout) {
        'ngInject';

        $rootScope.logoutSafe();
        ChaiWebSocket.stop();

    }
};
